export const version = '2.39.0';
//# sourceMappingURL=version.js.map